export default "__VITE_ASSET__DcJwJrvt__"